import api from "@/services/api";
import store from "@/store";
import { getCurrentWeekDate } from "@/helpers/js/current-week-date";
import { isLoggedIn, isAdmin } from "@/helpers/js/user";

export async function checkInspectionSubmitted() {
	if (!isLoggedIn()) return;
	const inspectionDate = await getCurrentWeekDate();
	let vehicleRegistration = "";
	try {
		const { Sort_Key } = store.state.user;
		if (Sort_Key && !isAdmin()) {
			const engineer = await api.request("get", "engineers?id=" + Sort_Key);
			vehicleRegistration = engineer.assigned_vehicle || "";
			// no vehicle means no inspection to do, so nothing to alert about
			if (!vehicleRegistration) {
				store.commit("setIsVehicleInspected", true);
				return;
			}
		}
		const result = await api.request(
			"get",
			`vehicle-inspections?scope=getCurrentWeekInspection&inspectionDate=${inspectionDate}&vehicleRegistration=${vehicleRegistration}`
		);
		const hasData = result && Object.keys(result).length > 0;
		store.commit("setIsVehicleInspected", hasData);
		return;
	} catch (err) {
		store.commit("setIsVehicleInspected", false);
		return;
	}
}

export async function getInspectionAlertClass() {
	if (!isLoggedIn()) return;
	const inspectionDate = await getCurrentWeekDate();
	const now = new Date();

	let year, month, day;
	if (inspectionDate?.includes("-")) {
		[year, month, day] = inspectionDate.split("-").map(Number);
	} else if (inspectionDate?.includes("/")) {
		[year, month, day] = inspectionDate.split("/").map(Number);
	} else {
		const d = new Date(inspectionDate);
		year = d.getFullYear();
		month = d.getMonth() + 1;
		day = d.getDate();
	}

	const inspectionDateObj = new Date(year, month - 1, day);
	const cutOffTime = new Date(year, month - 1, day, 13, 0, 0, 0);

	if (
		now.getFullYear() === inspectionDateObj.getFullYear() &&
		now.getMonth() === inspectionDateObj.getMonth() &&
		now.getDate() === inspectionDateObj.getDate()
	) {
		if (now < cutOffTime) {
			return "warning-allert";
		} else {
			return "error-allert";
		}
	}
	if (now > inspectionDateObj) {
		return "error-allert";
	}
	return "";
}
